module.exports = __webpack_public_path__ + "static/media/id8-casa_joao.f21b9ed7.jpg";